import React from 'react';
import classnames from 'classnames';
import styles from './link-list.scss';

type LinkListItem = {
  id?: string | number;
  name?: string;
  url?: string;
  external?: boolean;
  handler?: React.MouseEventHandler<HTMLAnchorElement>;
  menuLinks?: Array<{ name?: string; url?: string; external?: boolean }>;
};

type LinkItemComponentProps = {
  url?: string;
  external?: boolean;
  handler?: React.MouseEventHandler<HTMLAnchorElement>;
  menuLinks: Array<{ name?: string; url?: string; external?: boolean }>;
  children?: React.ReactNode;
};

type LinkListProps = {
  links: LinkListItem[];
  Item: React.ComponentType<LinkItemComponentProps>;
  className?: string;
  children?: React.ReactNode;
};

export const LinkList = ({
  links,
  Item,
  className,
  children,
}: LinkListProps) => (
  <ul className={classnames(styles.list, className)}>
    {links.map(link => (
      <Item
        key={link.name || link.url}
        url={link.url}
        external={link.external}
        handler={link.handler}
        menuLinks={link.menuLinks || []}
      >
        {link.name}
      </Item>
    ))}
    {children}
  </ul>
);
